module.exports = __webpack_public_path__ + "static/img-mask-05b00f3287116093f1712c543121ffb7.png";